<ng-template
  let-extraClass="extraClass"
  #topNav />

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-image
            [src]="'assets/img/account.svg'"
            class="header-size" />
          <tidy-text
            [header]="editingEmployee?.source_user_first_name + ' ' + editingEmployee?.source_user_last_name" />
          <tidy-text
            [body]="'Edit'"
            (action)="goToEditEmployeeDetailsPage()"
            class="link" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="editingEmployee?.source_user_email" />
        </tidy-row>
      </tidy-card>
      <tidy-row>
        <tidy-text
          [header]="'Credits'" />
      </tidy-row>
      @for (credit of employeeBalance?.transfers; track credit) {
        @if ((credit?.amount_sent - credit?.amount_used - credit?.amount_cancelled) > 0) {
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-image
                [src]="'assets/img/salary.svg'"
                class="body-size" />
              <tidy-text
                [body]="((credit?.amount_sent - credit?.amount_used - credit?.amount_cancelled) | tcurrency) + (' remaining of ' | translate) + (credit?.amount_sent | tcurrency) + (' credit' | translate)" />
              <tidy-text
                [body]="'Remove'"
                (action)="removeCredit(credit)"
                class="link" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [helper]="('Added on ' | translate) + (credit?.sent_at | parseDateTime: 'MMM d':'local')" />
            </tidy-row>
          </tidy-card>
        }
      }
      @if (employeeBalance?.lifetime_amount_sent - employeeBalance?.lifetime_amount_used - employeeBalance?.lifetime_amount_cancelled == 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'None'" />
          </tidy-row>
        </tidy-alert>
      }
      <tidy-button
        [action]="boundGoToAddEmployeeCreditPage"
        [text]="'Add Credit'"
        class="primary"
        [disabled]="companyCredit <= 0" />
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Delete Employee'"
          (action)="deleteEmployee()"
          class="red link" />
      </tidy-row>
      @if (companyCredit > 0) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="('You currently have ' | translate) + (companyCredit | tcurrency) + (' credit you can add for employees.' | translate)" />
        </tidy-row>
      }
      @if (companyCredit <= 0) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'You currently have $0 credit. Please add more credit to your account to add for employees. '" />
          <tidy-text
            [body]="'Add Credit'"
            class="link"
            (action)="goToAddCredit()" />
        </tidy-row>
      }
    }

  </tidy-wrapper>
</ng-template>

<ion-content class="ion-content-right-column">
  <ng-container *ngTemplateOutlet="content" />
</ion-content>
